"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._useChangeReviewer = exports.useChangeReviewer = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const FormalReviewClient_1 = require("client/FormalReviewClient");
const ChangeReviewerKeys_1 = __importDefault(require("consts/queryKeys/ChangeReviewerKeys"));
const HelperUtils_1 = require("utils/HelperUtils");
const useChangeReviewer = (cycleId, params, options) => {
    var _a;
    const _b = (0, exports._useChangeReviewer)(cycleId, params, options), { data } = _b, rest = __rest(_b, ["data"]);
    return Object.assign({ data: data ? (0, HelperUtils_1.flattenPages)(data === null || data === void 0 ? void 0 : data.pages) : [], metadata: (_a = data === null || data === void 0 ? void 0 : data.pages[0].metadata) === null || _a === void 0 ? void 0 : _a.metadata }, rest);
};
exports.useChangeReviewer = useChangeReviewer;
const _useChangeReviewer = (cycleId, params, options) => {
    const fetchRevieweeSelections = (olderThan) => {
        const queryParams = Object.assign(Object.assign({}, params), (olderThan && { olderThan }));
        return (0, FormalReviewClient_1.getRevieweeSelections)(cycleId, queryParams);
    };
    return (0, react_query_1.useInfiniteQuery)(ChangeReviewerKeys_1.default.selections(params), ({ pageParam }) => fetchRevieweeSelections(pageParam), Object.assign({ cacheTime: 0, getNextPageParam: (lastPage) => { var _a, _b; return ((_b = (_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.olderThan) || null; } }, options));
};
exports._useChangeReviewer = _useChangeReviewer;
